import React from 'react';

const Notifications=()=>{
    return(
        <div>
            <p></p>
        </div>
    )
}

export default Notifications;